import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./SurveyModal.scss";
import Modal from "../__common/Modal/Modal";
import { Checkbox } from "../__common/_controls/Checkbox/Checkbox";
import { Button } from "../__common/_controls";
import { Typography } from "../__common/Typography/Typography";
import TextArea from "../__common/TextArea/TextArea";
import {
  question1,
  question2,
  question3,
  question4,
} from "../../data/surveyQuestions";
import { useUserHooks } from "../../hooks/user-hooks";
import { ApplicationState } from "../../store";
import { UserState } from "../../store/reducers/user-reducer";
import {  useSelector } from "react-redux";
import { SHOW_SURVEY} from "../../constants/storage";
import { Cookie } from "../../services/storage";
import { Survey } from "../../types/user";
interface Props {
  isOpen: boolean;
  onHide?: () => void;
  id: string;
}

export const SurveyModal: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const { submitUserSurvey } = useUserHooks();
  const [surveyData, setSurveyData] = useState<Survey>({
    answer_1: "Very Satisfied",
    answer_2: "Very Satisfied",
    answer_3: "Very Satisfied",
    answer_4: "Very Satisfied",
    comments: "",
  });

  const userState = useSelector<ApplicationState, UserState>(
    (state) => state.user
  );
  const handleCheckboxOnChange = (questionNum: number, value: any) => {
    switch (questionNum) {
      case 1:
        setSurveyData({ ...surveyData, answer_1: value });
        break;
      case 2:
        setSurveyData({ ...surveyData, answer_2: value });
        break;
      case 3:
        setSurveyData({ ...surveyData, answer_3: value });
        break;
      case 4:
        setSurveyData({ ...surveyData, answer_4: value });
        break;
    }
  };

  useEffect(() => {
    if (props.isOpen) {
      Cookie.remove(SHOW_SURVEY);
    }
  }, [props.isOpen]);


  const showOptionalPlaceHolder = Object.values(surveyData).some(
    (val) => val === "Dissatisfied" || val === "Very Dissatisfied"
  );

  const handleSurveySubmit = () => {
    submitUserSurvey(surveyData);
  };
  return (
    <Modal
      testId="survey-modal"
      show={props.isOpen}
      wrapperClassName="survey-modal"
      id={props.id}
    >
      <Modal.Header
        headertestid="survey-modal-close-button"
        onHide={() => props.onHide?.()}
      >
        <Modal.Title>{t("PRIVACY_SURVEY_2025_TITLE")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="survey-modal__top-content subText">
          <Typography variant="body2">
            {t("PRIVACY_SURVEY_2025_DESC")}
          </Typography>
        </div>
        {userState.userSurvey.hasErrors && (
          <div className="survey-modal__error-message">
            <Typography variant="body2" className="error-text">
              {t("PRIVACY_SURVEY_ERROR_MESSAGE")}
            </Typography>
          </div>
        )}

        <div className="survey-modal__question">
          {/* q1 */}
          <Typography variant="title3" className="survey-modal__question__text">
            {t("PRIVACY_SURVEY_2025_Q1")}
          </Typography>
          <div className="survey-modal__form-container">
            {question1
              .map((e, index) => {
                return (
                  <Checkbox
                    testId="survey-checkbox"
                    type="withImg"
                    id={e.id}
                    key={e.id}
                    title={e.title}
                    name={e.name}
                    onKeyPress={() => handleCheckboxOnChange(1, e.name)}
                    checked={surveyData.answer_1 === e.name}
                    svgIcon={e.svg}
                    toolTip={t(e.altText)}
                    onChange={() => handleCheckboxOnChange(1, e.name)}
                  />
                );
              })
              .reverse()}
          </div>
          {/* q2 */}
          <Typography variant="title3" className="survey-modal__question__text">
            {t("PRIVACY_SURVEY_2025_Q2")}
          </Typography>
          <div className="survey-modal__form-container">
            {question2
              .map((e, index) => (
                <Checkbox
                  testId="survey-checkbox"
                  type="withImg"
                  id={e.id}
                  key={e.id}
                  title={e.title}
                  name={e.name}
                  onKeyPress={() => handleCheckboxOnChange(2, e.name)}
                  checked={surveyData.answer_2 === e.name}
                  svgIcon={e.svg}
                  toolTip={t(e.altText)}
                  onChange={() => handleCheckboxOnChange(2, e.name)}
                />
              ))
              .reverse()}
          </div>
          {/* q3 */}
          <Typography variant="title3" className="survey-modal__question__text">
            {t("PRIVACY_SURVEY_2025_Q3")}
          </Typography>
          <div className="survey-modal__form-container">
            {question3
              .map((e, index) => (
                <Checkbox
                  testId="survey-checkbox"
                  type="withImg"
                  id={e.id}
                  key={e.id}
                  title={e.title}
                  name={e.name}
                  onKeyPress={() => handleCheckboxOnChange(3, e.name)}
                  checked={surveyData.answer_3 === e.name}
                  svgIcon={e.svg}
                  toolTip={t(e.altText)}
                  onChange={() => handleCheckboxOnChange(3, e.name)}
                />
              ))
              .reverse()}
          </div>
          {/* q4 */}
          <Typography variant="title3" className="survey-modal__question__text">
            {t("PRIVACY_SURVEY_2025_Q4")}
          </Typography>
          <div className="survey-modal__form-container">
            {question4
              .map((e, index) => (
                <Checkbox
                  testId="survey-checkbox"
                  type="withImg"
                  id={e.id}
                  key={e.id}
                  title={e.title}
                  name={e.name}
                  onKeyPress={() => handleCheckboxOnChange(4, e.name)}
                  checked={surveyData.answer_4 === e.name}
                  svgIcon={e.svg}
                  toolTip={t(e.altText)}
                  onChange={() => handleCheckboxOnChange(4, e.name)}
                />
              ))
              .reverse()}
          </div>
          <TextArea
            testId="survey-text-area"
            className="survey-modal__textarea subText"
            placeHolder={
              t("PRIVACY_SURVEY_2025_Q5") +
              (showOptionalPlaceHolder
                ? `\n${t("PRIVACY_SURVEY_2025_Q5_ADDITIONAL")}`
                : "")
            }
            value={surveyData.comments}
            maxChars={500}
            onChange={(e) => {
              setSurveyData({ ...surveyData, comments: e.target.value });
            }}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="button-container">
          <Button
            className="survey-modal__submit"
            onClick={handleSurveySubmit}
            testId="submit-survey-button"
            title={t("PRIVACY_SURVEY_BTN_SEND")}
            disabled={
              userState.userSurvey.isSubmittingSurvey ||
              surveyData.answer_1 === "" ||
              surveyData.answer_2 === "" ||
              surveyData.answer_3 === "" ||
              surveyData.answer_4 === ""
            }
          ></Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
